import React from 'react';

export const SiteFooter = () => (
  <footer className="bg-black/90 border-t border-golden/20 py-8 px-4" data-testid="site-footer">
    <div className="container mx-auto">
      <div className="grid md:grid-cols-3 gap-8">
        <div className="text-center md:text-left">
          <div className="flex justify-center md:justify-start items-center mb-4">
            <img
              src="https://customer-assets.emergentagent.com/job_invest-links/artifacts/kydgz8tm_WhatsApp%20Image%202025-08-23%20at%203.47.06%20PM.jpeg"
              alt="Upper Circuit Stocks Logo"
              className="h-16 w-auto"
            />
          </div>
          <p className="text-gray-400 mb-2">© 2024 Upper Circuit Stocks by Chirag Rathod. All rights reserved.</p>
          <p className="text-golden text-sm">Trade smarter, not harder.</p>
        </div>

        <div className="text-center md:text-left">
          <h4 className="text-golden font-semibold mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li><a href="/home#about" className="text-gray-400 hover:text-golden transition-colors">About</a></li>
            <li><a href="/home#services" className="text-gray-400 hover:text-golden transition-colors">Services</a></li>
            <li><a href="/home#workshop" className="text-gray-400 hover:text-golden transition-colors">Workshop</a></li>
            <li><a href="/home#contact" className="text-gray-400 hover:text-golden transition-colors">Contact</a></li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h4 className="text-golden font-semibold mb-4">Legal</h4>
          <ul className="space-y-2">
            <li><a href="/privacy-policy" className="text-gray-400 hover:text-golden transition-colors" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            <li><a href="/cancellation-policy" className="text-gray-400 hover:text-golden transition-colors" target="_blank" rel="noopener noreferrer">Cancellation &amp; Refunds</a></li>
            <li><a href="/terms-and-conditions" className="text-gray-400 hover:text-golden transition-colors" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></li>
            <li><span className="text-gray-400 text-sm">Contact: chiragbrathod1988@gmail.com</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-golden/20 mt-8 pt-6 text-center">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-2 md:mb-0">
            All trading and investment services carry risk. Past performance does not guarantee future results.
          </p>
          <div className="flex space-x-4 text-sm">
            <a href="/privacy-policy" className="text-gray-500 hover:text-golden transition-colors">Privacy</a>
            <span className="text-gray-600">|</span>
            <a href="/cancellation-policy" className="text-gray-500 hover:text-golden transition-colors">Refunds</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
